import { render } from "./AddressDetailsSummary.vue?vue&type=template&id=c29b33a2"
import script from "./AddressDetailsSummary.vue?vue&type=script&lang=js"
export * from "./AddressDetailsSummary.vue?vue&type=script&lang=js"
script.render = render

export default script